import {
	BrowserRouter as Router,
	Redirect,
	Route,
	Switch,
} from "react-router-dom";
import { ClubView } from "./Components/Clubs/ClubView";
import { PrivateRoute } from "./Components/PrivateRoute";
import { AuthProvider } from "./contexts/authContext";
import { NotFound } from "./Pages/404";
import { ForgotPassword } from "./Pages/ForgotPassword";
import { Home } from "./Pages/Home";
import { Login } from "./Pages/Login";
import { Main } from "./Pages/Main";
import { Register } from "./Pages/Register";
import { UserProfile } from "./Pages/UserProfile";

const RedirectMain = () => <Redirect to="/main" />;

function App() {
	return (
		<AuthProvider>
			<Router>
				<Switch>
					{/* home */}
					<Route path="/" component={Home} exact />

					{/* main & clubs */}
					<PrivateRoute path="/main" component={Main} />
					<PrivateRoute path="/clubs/:clubid" component={ClubView} />
					<PrivateRoute path="/clubs" component={RedirectMain} />

					{/* me */}
					<PrivateRoute path="/@me" component={UserProfile} />

					{/* auto */}
					<Route path="/login" component={Login} />
					<Route path="/register" component={Register} />
					<Route path="/forgot-password" component={ForgotPassword} />

					{/* basically just 404s */}
					<Route path="*" component={NotFound} />
				</Switch>
			</Router>
		</AuthProvider>
	);
}

export default App;
